import {createSystem, defaultConfig, defineConfig} from "@chakra-ui/react"
import {tabsRecipe} from "./tabs";
import {segmentGroupRecipe} from "./segmented-group";
import {buttonRecipe} from "./button";

const customConfig = defineConfig({
    theme: {
        slotRecipes: {
            segmentGroup: segmentGroupRecipe,
            tabs: tabsRecipe,
        },
        recipes: {
          button: buttonRecipe
        },
        semanticTokens: {
            colors: {
                bg: {
                    muted: {
                        value: "transpared"
                    },
                },
                border: {
                    value: 'black'
                }
            }
        },
        tokens: {
            colors: {
                primary: { value: "#6f1d39" },
            },
            fonts: {
                heading: { value: "'Montserrat', sans-serif" },
                body: { value: "'Montserrat', sans-serif" },
            },
        },
    },
})

export const system = createSystem(defaultConfig, customConfig)
